$(document).ready(function () {
  var copyButton = document.getElementById('copy-button');
  var copyText = document.getElementById('copy-text');

  if (copyButton === null) {
    return;
  }

  copyButton.addEventListener('click', () => {
    navigator.clipboard.writeText(copyButton.innerHTML);

    copyText.classList.remove('d-none');

    setTimeout(() => {
      copyText.classList.add('d-none');
    }, 1000);
  });
});
